import { andJoin, createLabeledMessages } from '../../../messageUtils';
const policy = {
    duration: 'trvaní pojištění',
    paymentFrequency: 'frekvence placení',
    insuranceStart: 'počátek pojištění',
    insuranceStartTime: 'čas počátku pojištění',
    insuranceEnd: 'konec pojištění',
    agreementDate: 'datum sjednání',
    dayCount: 'počet dní',
    paymentPerYear: 'roční pojistné celkem',
    paymentValue: 'výše splátky',
    paymentType: 'způsob platby',
    creation: 'vznik pojistné smlouvy',
    specialAgreement: 'zvláštní ujednání',
    note: 'poznámka ke smlouvě',
    paceAndDate: andJoin('address:place_label', 'policy:agreementDate'),
    insuranceType: 'typ pojištění'
};
export default Object.assign({}, policy, createLabeledMessages(policy));
